package com.iregained.site.components.sections.promo.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.iregained.site.components.sections.product.sections.ProductDemonstrationSection
import com.iregained.site.components.sections.promo.sections.PromoBookingSection
import com.iregained.site.components.sections.promo.sections.PromoHeroSection
import com.iregained.site.components.sections.promo.sections.PromoValueSection
import com.iregained.site.components.sections.resources.sections.ResourcesBrochureDownloadSection
import com.iregained.site.components.widgets.BackToTopButton
import com.iregained.site.theme.toSitePalette
import com.iregained.site.utils.LocalBreakpoint
import com.iregained.site.utils.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import kotlinx.browser.document
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Sup
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLMetaElement

// A simple routing strip at the bottom of the page
@Composable
fun PromoFooterExitSection() {
    val breakpoint = LocalBreakpoint.current
    val isDesktop = breakpoint >= Res.Breakpoints.LG
    val palette = ColorMode.current.toSitePalette()

    Column(
        modifier = Modifier.fillMaxWidth()
            .backgroundColor(palette.brand.primary) // Dark background to contrast with the white brochure section
            .padding(topBottom = if (isDesktop) 60.px else 40.px, leftRight = 5.percent),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Div(
            attrs = Modifier.color(Colors.White).fontSize(if (isDesktop) 42.px else 28.px)
                .fontWeight(FontWeight.Bold).lineHeight(1.1).margin(bottom = 42.px)
                .staggeredText(delayMs = 250).toAttrs()
        ) {
            Text("Explore more about MyHand")
            Sup { Text("®") }
            Text(" System.")
        }
        Link(
            path = "/",
            modifier = Modifier.textDecorationLine(TextDecorationLine.None)
        ) {
            Box(
                modifier = Modifier
                    .border(1.px, LineStyle.Solid, Colors.White)
                    .padding(topBottom = 12.px, leftRight = 24.px)
                    .borderRadius(8.px),
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    text = "Go to Main Website",
                    modifier = Modifier.color(Colors.White).fontWeight(FontWeight.SemiBold)
                )
            }
        }
    }
}

@Composable
private fun Modifier.staggeredText(delayMs: Int): Modifier = this.animation(
    TextSlideUpKeyframes.toAnimation(
        duration = 0.8.s,
        timingFunction = AnimationTimingFunction.EaseOut,
        delay = delayMs.ms,
        fillMode = AnimationFillMode.Both
    )
)